import Auth from './api/Auth.service'
import Med from './api/Med.service'
import MedGroup from './api/MedGroup.service'
import Common from "./api/Common.service";

export default {
  Auth,
  Med,
  MedGroup,
  Common,
}
